import { __decorate, __param } from '../../../../../node_modules/tslib/tslib.es6.js';
import { Event } from 'monaco-editor/esm/vs/base/common/event.js';
import { DisposableStore } from 'monaco-editor/esm/vs/base/common/lifecycle.js';
import { URI } from 'monaco-editor/esm/vs/base/common/uri.js';
import { IOpenerService } from 'monaco-editor/esm/vs/platform/opener/common/opener.js';
import { extHostNamedCustomer } from '../../services/extensions/common/extHostCustomers.js';
import { ExtHostContext, MainContext } from '../common/extHost.protocol.js';
import { IHostService } from '../../services/host/browser/host.js';
let MainThreadWindow = class MainThreadWindow {
    constructor(extHostContext, hostService, openerService) {
        this.hostService = hostService;
        this.openerService = openerService;
        this.disposables = ( new DisposableStore());
        this.proxy = ( extHostContext.getProxy(ExtHostContext.ExtHostWindow));
        Event.latch(hostService.onDidChangeFocus)(this.proxy.$onDidChangeWindowFocus, this.proxy, this.disposables);
    }
    dispose() {
        this.disposables.dispose();
    }
    $getWindowVisibility() {
        return Promise.resolve(this.hostService.hasFocus);
    }
    async $openUri(uriComponents, uriString, options) {
        const uri = ( URI.from(uriComponents));
        let target;
        if (uriString && ( ( URI.parse(uriString)).toString()) === ( uri.toString())) {
            target = uriString;
        }
        else {
            target = uri;
        }
        return this.openerService.open(target, {
            openExternal: true,
            allowTunneling: options.allowTunneling,
            allowContributedOpeners: options.allowContributedOpeners,
        });
    }
    async $asExternalUri(uriComponents, options) {
        const result = await this.openerService.resolveExternalUri(URI.revive(uriComponents), options);
        return result.resolved;
    }
};
MainThreadWindow = __decorate([
    extHostNamedCustomer(MainContext.MainThreadWindow),
    ( __param(1, IHostService)),
    ( __param(2, IOpenerService))
], MainThreadWindow);
export { MainThreadWindow };
